export interface PublicDealsRetailer {
  slug: string;
  apiRetailer: string;
  storeId: "online";
  name: string;
  shortName: string;
  domain: string;
  /** Shown instead of the domain wherever the store is named to shoppers (Home Depot is always "HD"). */
  displayName?: string;
  accent: string;
}

/**
 * The single source of truth for anonymous online feeds. Keep this list aligned
 * with the server's /public/products/browse allowlist; it is intentionally not
 * derived from paid-plan configuration.
 */
export const PUBLIC_DEALS_RETAILERS: readonly PublicDealsRetailer[] = [
  {
    slug: "walmart",
    apiRetailer: "walmart",
    storeId: "online",
    name: "Walmart Online",
    shortName: "Walmart",
    domain: "Walmart.com",
    accent: "#0071CE",
  },
  {
    slug: "home-depot",
    apiRetailer: "home_depot",
    storeId: "online",
    name: "HD Online",
    shortName: "HD",
    domain: "HomeDepot.com",
    displayName: "HD",
    accent: "#F96302",
  },
  {
    slug: "lowes",
    apiRetailer: "lowes",
    storeId: "online",
    name: "Lowe's Online",
    shortName: "Lowe's",
    domain: "Lowes.com",
    accent: "#004990",
  },
  {
    slug: "tractor-supply",
    apiRetailer: "tractor_supply",
    storeId: "online",
    name: "Tractor Supply Online",
    shortName: "Tractor Supply",
    domain: "TractorSupply.com",
    accent: "#B31B34",
  },
  {
    slug: "northern-tool",
    apiRetailer: "northern_tool",
    storeId: "online",
    name: "Northern Tool Online",
    shortName: "Northern Tool",
    domain: "NorthernTool.com",
    accent: "#D71920",
  },
  {
    slug: "target",
    apiRetailer: "target",
    storeId: "online",
    name: "Target Online",
    shortName: "Target",
    domain: "Target.com",
    accent: "#CC0000",
  },
  {
    slug: "best-buy",
    apiRetailer: "bestbuy",
    storeId: "online",
    name: "Best Buy Online",
    shortName: "Best Buy",
    domain: "BestBuy.com",
    accent: "#0046BE",
  },
  {
    slug: "costco",
    apiRetailer: "costco",
    storeId: "online",
    name: "Costco Online",
    shortName: "Costco",
    domain: "Costco.com",
    accent: "#005DAA",
  },
  {
    slug: "amazon",
    apiRetailer: "amazon",
    storeId: "online",
    name: "Amazon",
    shortName: "Amazon",
    domain: "Amazon.com",
    accent: "#FF9900",
  },
  {
    slug: "kohls",
    apiRetailer: "kohls",
    storeId: "online",
    name: "Kohl's Online",
    shortName: "Kohl's",
    domain: "Kohls.com",
    accent: "#5E2B97",
  },
  {
    slug: "woot",
    apiRetailer: "woot",
    storeId: "online",
    name: "Woot",
    shortName: "Woot",
    domain: "Woot.com",
    accent: "#6BAB45",
  },
  {
    slug: "newegg",
    apiRetailer: "newegg",
    storeId: "online",
    name: "Newegg",
    shortName: "Newegg",
    domain: "Newegg.com",
    accent: "#E87511",
  },
  {
    slug: "gamestop",
    apiRetailer: "gamestop",
    storeId: "online",
    name: "GameStop",
    shortName: "GameStop",
    domain: "GameStop.com",
    accent: "#E31837",
  },
  {
    slug: "bjs",
    apiRetailer: "bjs",
    storeId: "online",
    name: "BJ's Wholesale",
    shortName: "BJ's",
    domain: "BJs.com",
    accent: "#E4002B",
  },
  {
    slug: "meijer",
    apiRetailer: "meijer",
    storeId: "online",
    name: "Meijer",
    shortName: "Meijer",
    domain: "Meijer.com",
    accent: "#D5202B",
  },
  {
    slug: "menards",
    apiRetailer: "menards",
    storeId: "online",
    name: "Menards",
    shortName: "Menards",
    domain: "Menards.com",
    accent: "#007A33",
  },
  {
    slug: "academy",
    apiRetailer: "academy",
    storeId: "online",
    name: "Academy Sports",
    shortName: "Academy",
    domain: "Academy.com",
    accent: "#003087",
  },
  {
    slug: "walgreens",
    apiRetailer: "walgreens",
    storeId: "online",
    name: "Walgreens",
    shortName: "Walgreens",
    domain: "Walgreens.com",
    accent: "#E31837",
  },
  {
    slug: "zappos",
    apiRetailer: "zappos",
    storeId: "online",
    name: "Zappos",
    shortName: "Zappos",
    domain: "Zappos.com",
    accent: "#0071BC",
  },
  {
    slug: "jcpenney",
    apiRetailer: "jcpenney",
    storeId: "online",
    name: "JCPenney",
    shortName: "JCPenney",
    domain: "JCPenney.com",
    accent: "#CE0E2D",
  },
  {
    slug: "belk",
    apiRetailer: "belk",
    storeId: "online",
    name: "Belk",
    shortName: "Belk",
    domain: "Belk.com",
    accent: "#00A6A0",
  },
  {
    slug: "michaels",
    apiRetailer: "michaels",
    storeId: "online",
    name: "Michaels",
    shortName: "Michaels",
    domain: "Michaels.com",
    accent: "#E4002B",
  },
  {
    slug: "nike",
    apiRetailer: "nike",
    storeId: "online",
    name: "Nike",
    shortName: "Nike",
    domain: "Nike.com",
    accent: "#111111",
  },
  {
    slug: "adidas",
    apiRetailer: "adidas",
    storeId: "online",
    name: "Adidas",
    shortName: "Adidas",
    domain: "Adidas.com",
    accent: "#111111",
  },
  {
    slug: "reebok",
    apiRetailer: "reebok",
    storeId: "online",
    name: "Reebok",
    shortName: "Reebok",
    domain: "Reebok.com",
    accent: "#E01A2B",
  },
  {
    slug: "skechers",
    apiRetailer: "skechers",
    storeId: "online",
    name: "Skechers",
    shortName: "Skechers",
    domain: "Skechers.com",
    accent: "#003D7D",
  },
  {
    slug: "puma",
    apiRetailer: "puma",
    storeId: "online",
    name: "Puma",
    shortName: "Puma",
    domain: "Puma.com",
    accent: "#C8102E",
  },
  {
    slug: "underarmour",
    apiRetailer: "underarmour",
    storeId: "online",
    name: "Under Armour",
    shortName: "Under Armour",
    domain: "UnderArmour.com",
    accent: "#1D1D1D",
  },
  {
    slug: "columbia",
    apiRetailer: "columbia",
    storeId: "online",
    name: "Columbia",
    shortName: "Columbia",
    domain: "Columbia.com",
    accent: "#003DA5",
  },
  {
    slug: "nordstromrack",
    apiRetailer: "nordstromrack",
    storeId: "online",
    name: "Nordstrom Rack",
    shortName: "Nordstrom Rack",
    domain: "NordstromRack.com",
    accent: "#C8102E",
  },
  {
    slug: "aldo",
    apiRetailer: "aldo",
    storeId: "online",
    name: "Aldo",
    shortName: "Aldo",
    domain: "AldoShoes.com",
    accent: "#111111",
  },
  {
    slug: "vitacost",
    apiRetailer: "vitacost",
    storeId: "online",
    name: "Vitacost",
    shortName: "Vitacost",
    domain: "Vitacost.com",
    accent: "#6CB33F",
  },
  {
    slug: "journeys",
    apiRetailer: "journeys",
    storeId: "online",
    name: "Journeys",
    shortName: "Journeys",
    domain: "Journeys.com",
    accent: "#111111",
  },
  {
    slug: "shopdisney",
    apiRetailer: "shopdisney",
    storeId: "online",
    name: "shopDisney",
    shortName: "shopDisney",
    domain: "DisneyStore.com",
    accent: "#1A6FB5",
  },
  {
    slug: "ninjakitchen",
    apiRetailer: "ninjakitchen",
    storeId: "online",
    name: "Ninja Kitchen",
    shortName: "Ninja Kitchen",
    domain: "NinjaKitchen.com",
    accent: "#D91E2A",
  },
  {
    slug: "hottopic",
    apiRetailer: "hottopic",
    storeId: "online",
    name: "Hot Topic",
    shortName: "Hot Topic",
    domain: "HotTopic.com",
    accent: "#E4002B",
  },
  {
    slug: "officedepot",
    apiRetailer: "officedepot",
    storeId: "online",
    name: "Office Depot",
    shortName: "Office Depot",
    domain: "OfficeDepot.com",
    accent: "#D6002B",
  },
  {
    slug: "barnesnoble",
    apiRetailer: "barnesnoble",
    storeId: "online",
    name: "Barnes & Noble",
    shortName: "Barnes & Noble",
    domain: "BarnesAndNoble.com",
    accent: "#00704A",
  },
  {
    slug: "razer",
    apiRetailer: "razer",
    storeId: "online",
    name: "Razer",
    shortName: "Razer",
    domain: "Razer.com",
    accent: "#44D62C",
  },
  {
    slug: "pacsun",
    apiRetailer: "pacsun",
    storeId: "online",
    name: "PacSun",
    shortName: "PacSun",
    domain: "PacSun.com",
    accent: "#111111",
  },
  {
    slug: "bathbodyworks",
    apiRetailer: "bathbodyworks",
    storeId: "online",
    name: "Bath & Body Works",
    shortName: "Bath & Body Works",
    domain: "BathAndBodyWorks.com",
    accent: "#003D5B",
  },
  {
    slug: "staples",
    apiRetailer: "staples",
    storeId: "online",
    name: "Staples",
    shortName: "Staples",
    domain: "Staples.com",
    accent: "#CC0000",
  },
  {
    slug: "petsmart", apiRetailer: "petsmart", storeId: "online", name: "PetSmart",
    shortName: "PetSmart", domain: "PetSmart.com", accent: "#00549E",
  },
  {
    slug: "ulta", apiRetailer: "ulta", storeId: "online", name: "Ulta Beauty",
    shortName: "Ulta", domain: "Ulta.com", accent: "#E86F25",
  },
  {
    slug: "forever21", apiRetailer: "forever21", storeId: "online", name: "Forever 21",
    shortName: "Forever 21", domain: "Forever21.com", accent: "#111111",
  },
  {
    slug: "gap", apiRetailer: "gap", storeId: "online", name: "Gap",
    shortName: "Gap", domain: "Gap.com", accent: "#000F4D",
  },
  {
    slug: "petco", apiRetailer: "petco", storeId: "online", name: "Petco",
    shortName: "Petco", domain: "Petco.com", accent: "#001952",
  },
  {
    slug: "americaneagle", apiRetailer: "americaneagle", storeId: "online", name: "American Eagle",
    shortName: "American Eagle", domain: "AE.com", accent: "#24272A",
  },
  {
    slug: "aerie", apiRetailer: "aerie", storeId: "online", name: "Aerie",
    shortName: "Aerie", domain: "AE.com", accent: "#6F6259",
  },
  {
    slug: "abercrombie", apiRetailer: "abercrombie", storeId: "online", name: "Abercrombie & Fitch",
    shortName: "Abercrombie", domain: "Abercrombie.com", accent: "#1D1D1B",
  },
  {
    slug: "hollister", apiRetailer: "hollister", storeId: "online", name: "Hollister",
    shortName: "Hollister", domain: "HollisterCo.com", accent: "#734B32",
  },
  {
    slug: "oldnavy", apiRetailer: "oldnavy", storeId: "online", name: "Old Navy",
    shortName: "Old Navy", domain: "OldNavy.com", accent: "#003764",
  },
  {
    slug: "bananarepublic", apiRetailer: "bananarepublic", storeId: "online", name: "Banana Republic",
    shortName: "Banana Republic", domain: "BananaRepublic.com", accent: "#2B2A27",
  },
  {
    slug: "stevemadden", apiRetailer: "stevemadden", storeId: "online", name: "Steve Madden",
    shortName: "Steve Madden", domain: "SteveMadden.com", accent: "#D71920",
  },
  {
    slug: "athleta", apiRetailer: "athleta", storeId: "online", name: "Athleta",
    shortName: "Athleta", domain: "Athleta.com", accent: "#556B5D",
  },
  {
    slug: "gapfactory", apiRetailer: "gapfactory", storeId: "online", name: "Gap Factory",
    shortName: "Gap Factory", domain: "GapFactory.com", accent: "#001F5B",
  },
  {
    slug: "bananarepublicfactory", apiRetailer: "bananarepublicfactory", storeId: "online", name: "Banana Republic Factory",
    shortName: "BR Factory", domain: "BananaRepublicFactory.com", accent: "#403F3C",
  },
  {
    slug: "boxlunch", apiRetailer: "boxlunch", storeId: "online", name: "BoxLunch",
    shortName: "BoxLunch", domain: "BoxLunch.com", accent: "#E31837",
  },
  {
    slug: "verabradley", apiRetailer: "verabradley", storeId: "online", name: "Vera Bradley",
    shortName: "Vera Bradley", domain: "VeraBradley.com", accent: "#5C2D91",
  },
  {
    slug: "footlocker", apiRetailer: "footlocker", storeId: "online", name: "Foot Locker",
    shortName: "Foot Locker", domain: "FootLocker.com", accent: "#D71920",
  },
  {
    slug: "champs", apiRetailer: "champs", storeId: "online", name: "Champs Sports",
    shortName: "Champs", domain: "ChampsSports.com", accent: "#E31837",
  },
] as const;

export const DEFAULT_PUBLIC_DEALS_RETAILER = PUBLIC_DEALS_RETAILERS[0];

export function getPublicDealsRetailer(slug?: string | null) {
  if (!slug) return DEFAULT_PUBLIC_DEALS_RETAILER;
  return PUBLIC_DEALS_RETAILERS.find((retailer) => retailer.slug === slug);
}

/** The logged-out feed: "/", "/walmart", "/walmart/deals", "/walmart/toys". */
/** "/stores": the logged-out A–Z list of every online store, served by the home feed page. */
export const STORES_INDEX_PATH = "/stores";
/** "/clearance": nearby in-store clearance, one store at a time, served by the home feed page. */
export const CLEARANCE_PATH = "/clearance";

export function isHomeFeedPath(pathname: string): boolean {
  if (pathname === "/" || pathname === "" || pathname === STORES_INDEX_PATH || pathname === CLEARANCE_PATH) return true;
  const segments = pathname.split("/").filter(Boolean);
  // "/walmart", "/walmart/toys" and a deal's own page, "/walmart/item/<key>".
  const isItemPage = segments.length === 3 && segments[1] === "item";
  if (segments.length < 1 || (segments.length > 2 && !isItemPage)) return false;
  try {
    return isPublicDealsRetailerSlug(decodeURIComponent(segments[0]));
  } catch {
    return false;
  }
}

export function isPublicDealsRetailerSlug(slug?: string | null): boolean {
  return !!slug && !!getPublicDealsRetailer(slug);
}

export function getPublicDealsPath(slug: string): string {
  return slug === DEFAULT_PUBLIC_DEALS_RETAILER.slug ? "/deals" : `/deals/${slug}`;
}

const STORE_GRID_PARAMS = ["sort", "status", "discount", "minPrice", "maxPrice"] as const;

/**
 * Where an old guest catalog URL ("/deals", "/deals/target?status=new") lives on the store
 * feed: a linked product opens its deal page, a category its aisle, everything else the
 * store's All deals grid with the same filters.
 */
export function storeGridPathForLegacyDeals(slug: string | undefined, search: string): string {
  const retailer = getPublicDealsRetailer(slug) || DEFAULT_PUBLIC_DEALS_RETAILER;
  const params = new URLSearchParams(search);
  const product = params.get("product");
  if (product) return `/${retailer.slug}/item/${encodeURIComponent(product)}`;
  const kept = new URLSearchParams();
  for (const key of STORE_GRID_PARAMS) {
    const value = params.get(key);
    if (value) kept.set(key, value);
  }
  const category = params.get("category");
  const section = category && /^[a-z0-9-]+$/i.test(category) ? category : "deals";
  const query = kept.toString();
  return `/${retailer.slug}/${section}${query ? `?${query}` : ""}`;
}

export function isPublicDealsPath(pathname: string): boolean {
  if (pathname === "/deals" || pathname === "/deals/") return true;
  const match = pathname.match(/^\/deals\/([^/?#]+)\/?$/);
  return !!match && isPublicDealsRetailerSlug(decodeURIComponent(match[1]));
}
